import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventCard } from 'src/domains/sportsbook/webview/components/eventCard/EventCard';
import { CarouselEventNavigation } from 'src/domains/layouts/webview/components/eventNavigation/CarouselEventNavigation';
import { LayoutSkeleton } from 'src/domains/layouts/webview/modules/LayoutSkeleton';
import { PriceChangeLegend } from 'src/domains/layouts/webview/components/priceChangeLegend/PriceChangeLegend';
import { AlternativeEvent } from 'src/domains/sportsbook/webview/modules/AlternativeEvent';
import { useAppStateContext } from 'src/appState/AppState';
import { EventRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { Wrapper, Event } from './EventPage.style';
import {
    BackButton,
    EventNavigation,
} from 'src/domains/layouts/webview/components/eventNavigation/CarouselSelection.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';

interface EventLayoutPropsType {
    currentView: EventRouteType;
    isSearchActive: boolean;
    accountView: RightHandSideViewType | null;
    isNotificationsList: boolean;
}

export const EventLayout = observer('EventLayout', (props: EventLayoutPropsType) => {
    const { currentView, accountView, isSearchActive, isNotificationsList } = props;

    const { appSportsBookState } = useAppStateContext();
    const common = useCommon();

    const configState = ConfigComponents.get(common).config;
    const starRouter = StarRouter.get(common);
    const { alternativeEventState, models } = appSportsBookState;

    const currentViewId = models.id.getEventId(currentView.id);
    const actualEvent = currentViewId.getEventModel();
    const isRacing = actualEvent === null ? false : ['greyhoundracing', 'horseracing'].includes(actualEvent.sport);
    const { isAlternativeEvent } = alternativeEventState.get(currentViewId);

    if (isAlternativeEvent) {
        return (
            <Event>
                <LayoutSkeleton
                    currentView={currentView}
                    accountView={accountView}
                    isSearchActive={isSearchActive}
                    navigationType='global'
                >
                    <Wrapper variant={configState.componentVariants.sportsbookVariant}>
                        <AlternativeEvent currentView={currentView} />
                    </Wrapper>
                </LayoutSkeleton>
            </Event>
        );
    }

    const handleRedirectToCompetitionPage = (): void => {
        starRouter.redirectToPreviousPage(() => {
            if (actualEvent !== null) {
                starRouter.redirectToCompetitionPage(actualEvent.competition, actualEvent.sport);
            }
        });
    };

    return (
        <Event>
            <LayoutSkeleton
                currentView={currentView}
                accountView={accountView}
                isSearchActive={isSearchActive}
                navigationType='global'
            >
                <Wrapper variant={configState.componentVariants.sportsbookVariant}>
                    {isRacing !== true && (
                        <EventNavigation>
                            <BackButton
                                onClick={handleRedirectToCompetitionPage}
                                position='left'
                            />

                            <CarouselEventNavigation currentView={currentView} />
                        </EventNavigation>
                    )}
                    <EventCard
                        eventId={appSportsBookState.models.id.getEventId(currentView.id)}
                        isNotificationsList={isNotificationsList}
                    />
                    {isRacing === true ? <PriceChangeLegend isRace={false} /> : null}
                </Wrapper>
            </LayoutSkeleton>
        </Event>
    );
});
